import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Mixpanel from 'helpers/Mixpanel.js';
import { submitAdvancedSearch, UPDATE_ADVANCED_SEARCH } from 'components/Pages/AdvancedSearch/actions.js';
import { SelectedTag, TagText } from './styled.js';

/**
 * The KeywordSearchLink should only be used to fill & navigate to
 * the search.
 * @param {*} props
 */
class KeywordSearchLink extends Component {
  search(event, keyword) {
    Mixpanel.track('Clicked keyword link', { keyword });
    event.preventDefault();
    event.stopPropagation();
    const { updateSearch, submit, history, onClick } = this.props;
    onClick && onClick();
    updateSearch('keyword_tags', [keyword]);
    submit();
    history.push('/blueprint/search');
  }

  render() {
    const { data: { value }, type } = this.props;

    if (type && type === 'text') {
      return (<TagText onClick={(e) => this.search(e, value)}>
        {value}
      </TagText>);
    }

    return (
      <SelectedTag clickable onClick={(e) => this.search(e, value)} type="keyword">
        <TagText>
          {value}
        </TagText>
      </SelectedTag>
    );
  }
}


const mapDispatchToProps = dispatch => ({
  updateSearch: (field, value) => dispatch({ type: UPDATE_ADVANCED_SEARCH, data: { field, value } }),
  submit: () => dispatch(submitAdvancedSearch()),
});

export default withRouter(connect(null, mapDispatchToProps)(KeywordSearchLink));
